import { Cascader, Modal } from 'rsuite';
import styled from 'styled-components';

export const PDFViewerModal = styled(Modal)`
  display: flex;
  justify-content: center;
  width: 80%;
  max-width: 1400px;

  .rs-modal-dialog {
    margin: auto;
  }

  .rs-modal-content {
    padding: 30px 0px 20px 0px;
  }
`;

export const FlexRowCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ViewerWrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  max-height: 680px;
  height: 75vh;
  margin-left: ${(props) => (props.printMode ? '10px' : '')};

  @media print {
    display: block !important;

    /* @page {
      // These are the exact dimensions of the image created from the PDF pages
      size: 1440px 2036px !important;
      margin: 0;
    } */
  }
`;

export const PrintWrapper = styled.div`
  margin-left: ${(props) => (props.printMode ? '-10px' : '')};
  .print-content {
    overflow-y: scroll;
  }
  @media print {
    .print-content {
      overflow-y: unset;
    }
  }
`;

export const ListingHistory = styled.div`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1;
  font-weight: 600;
  ::before {
    content: 'Listing History';
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 30px 15px 30px;

  .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
    color: rgba(0, 0, 0, 0.85);
  }

  .rs-picker-has-value .rs-btn .rs-picker-toggle-value,
  .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
    color: rgba(0, 0, 0, 0.85);
  }

  .rs-picker-toggle-clean {
    top: 5px;
  }

  .rs-picker-toggle-caret {
    top: 5px;
  }

  .rs-picker-toggle {
    height: 30px;
    padding: 5px 12px;
  }

  .rs-picker-default .rs-picker-toggle-custom.rs-btn-sm {
    padding-bottom: 4px;
    padding-top: 6px;
  }

  .rs-picker-search-input {
    padding: 5px 11px;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 30px;
  width: 100%;
  justify-content: flex-end;
`;

export const StyledDownloadText = styled.a`
  color: #ffffff;
  text-decoration: none;
  ::before {
    content: 'Download';
  }

  :active {
    color: #ffffff;
    text-decoration: none;
  }

  :hover {
    color: #ffffff;
    text-decoration: none;
  }

  :focus {
    color: #ffffff;
    text-decoration: none;
  }
`;

export const StyledCascader = styled(Cascader)`
  margin: 0px 10px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  height: 600px;
  align-items: center;
  justify-content: center;
`;
